import { Component, OnInit } from '@angular/core';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ConsultationModel } from '../../../models/master-data/consultations.model';
import { ConsultationsService } from './consultations.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { ModifyConsultationsPopupComponent } from './modify-consultations-popup.component';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'consultations',
    templateUrl: 'consultations.component.html',
    providers: [ConsultationsService]
})

export class ConsultationsComponent extends TMBDataTableComponent implements OnInit {
  dataRow = new Array < ConsultationModel > ();
  filterData = {
    consultationName: '',
    centreId: ''
  };
  public listCurencies = [];

  // currency Model
  public selectedCurrency: any = {
    code: '',
    id: '',
    symbol: '',
    symbolPosition: 'L',
    rate: 1
  };

  constructor(public dialogService: DialogService,
    public sharedService: SharedService,
    public utility: Utility,
    private consultationsService: ConsultationsService) {
    super(sharedService);
  }

  ngOnInit() {
    this.filterData.centreId = localStorage.getItem(AppConstants.localStorage.centreId);

    this.getCurrency();
    this.setPage({
      offset: 0
    });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      consultationName: this.filterData.consultationName
    };

    this.consultationsService.getConsultationList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dataRow = data['list'];
          this.page.pageNumber = pageInfo.offset;
          this.page.totalElements = data['totalRecords'];
        }
      },
      error => {}
    );
  }

  getCurrency() {
    this.consultationsService.getCurrencies(this.filterData.centreId).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.listCurencies = data;

          // Get default currency
          this.listCurencies.forEach(item => {
            if (item.code === item.from) {
              this.selectedCurrency = item;
            }
          });

        }
      }
    );
  }

  onFilter() {
    this.setPage({offset: 0});
  }

  onEditItem(dataItem) {
    const data = {
      id: dataItem.consultationFeeId,
      name: dataItem.item
    };
    this.dialogService.openComponentDialog(ModifyConsultationsPopupComponent, data).subscribe(
      (result) => {
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      }
    );
  }

  onRemoveItem(id) {
    this.dialogService.openConfirmationDialog({message: AppMessages.consultation.removeConsultation}).subscribe(
      (result) => {
        if (result) {
          this.consultationsService.deleteConsultation(id).subscribe(
            deleteResult => {
              if (deleteResult) {
                this.reloadPage(this.page.pageNumber, this.dataRow, true);
              }
            }
          );
        }
      });
  }

  addNewConsultation() {
    this.dialogService.openComponentDialog(ModifyConsultationsPopupComponent, {}).subscribe(
      (result) => {
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      }
    );
  }

  roundPriceNumber(num) {
    return Math.round(num * 100) / 100;
  }

  /**
 * change taxNum to %
 * @param taxNum
 */
  changeTaxPrice(taxNum) {
    return this.roundPriceNumber(parseFloat(taxNum) * 100);
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/consultations/consultations.component.ts